import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EstampCustomerComponent } from './estamp-customer/estamp-customer.component';
import { InventoryComponent } from './inventory/inventory.component';
import { ClientOrderComponent } from './client-order/client-order.component';
import { StateComponent } from './state/state.component';
import { UserComponent } from './user/user.component';
import { ClientOrderDetailComponent } from './client-order/client-order-detail/client-order-detail.component';

const routes: Routes = [
  { path: 'customer', component: EstampCustomerComponent },
  { path: 'inventory', component: InventoryComponent },
  { path: 'client-order', component: ClientOrderComponent },
  { path: 'client-order-detail/:id', component: ClientOrderDetailComponent },
  { path: 'state', component: StateComponent },
  { path: 'role', component: UserComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EstampRoutingModule { }